import { render, staticRenderFns } from "./page-paragraph.vue?vue&type=template&id=6070b56a&scoped=true"
import script from "./page-paragraph.vue?vue&type=script&lang=js"
export * from "./page-paragraph.vue?vue&type=script&lang=js"
import style0 from "./page-paragraph.vue?vue&type=style&index=0&id=6070b56a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6070b56a",
  null
  
)

export default component.exports